import React, { useState } from 'react';
import { Container, Content, Form, Button, Panel, Message, Checkbox } from 'rsuite';
import { useNavigate, Link } from 'react-router-dom';

import NavigationBar from '../Shared/NavigationBar';
import { API_BASE } from '../../helpers/authFetch';

const Register = () => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setError('');
    setSuccess('');

    if (!email || !username || !password || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, username }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Registration failed');
        return;
      }

      setSuccess('Account created successfully! Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError('Unable to connect to server');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    panel: {
      maxWidth: 400,
      margin: '60px auto',
    },
  };

  return (
    <>
      <NavigationBar />
      <Container>
        <Content>
          <Panel header="Register" bordered style={styles.panel}>
            {error && (
              <Message type="error" showIcon style={{ marginBottom: 16 }}>
                {error}
              </Message>
            )}
            {success && (
              <Message type="success" showIcon style={{ marginBottom: 16 }}>
                {success}
              </Message>
            )}
            <Form fluid>
              <Form.Group>
                <Form.ControlLabel>Display Name</Form.ControlLabel>
                <Form.Control
                  name="username"
                  value={username}
                  onChange={setUsername}
                  placeholder="Choose a display name"
                />
              </Form.Group>
              <Form.Group>
                <Form.ControlLabel>Email</Form.ControlLabel>
                <Form.Control
                  name="email"
                  type="email"
                  value={email}
                  onChange={setEmail}
                  placeholder="Enter your email"
                />
              </Form.Group>
              <Form.Group>
                <Form.ControlLabel>Password</Form.ControlLabel>
                <Form.Control
                  name="password"
                  type="password"
                  value={password}
                  onChange={setPassword}
                  placeholder="Enter a password"
                />
              </Form.Group>
              <Form.Group>
                <Form.ControlLabel>Confirm Password</Form.ControlLabel>
                <Form.Control
                  name="confirmPassword"
                  type="password"
                  value={confirmPassword}
                  onChange={setConfirmPassword}
                  placeholder="Confirm your password"
                />
              </Form.Group>
              <Form.Group>
                <Checkbox onChange={(_, checked) => setAgreed(checked)}>
                  I agree to the{' '}
                  <Link to="/terms" target="_blank" rel="noreferrer">Terms of Service</Link>
                  {' '}and{' '}
                  <Link to="/privacy" target="_blank" rel="noreferrer">Privacy Policy</Link>
                  .
                </Checkbox>
              </Form.Group>
              <Form.Group>
                <Button
                  appearance="primary"
                  block
                  loading={loading}
                  disabled={!agreed || loading}
                  onClick={handleSubmit}
                >
                  Register
                </Button>
              </Form.Group>
            </Form>
            <p style={{ marginTop: 16, textAlign: 'center' }}>
              Already have an account? <Link to="/login">Login here</Link>
            </p>
          </Panel>
        </Content>
      </Container>
    </>
  );
};

export default Register;
